/*
 * @Author: wzc
 * @Date: 2021-10-25 10:42:36
 * @LastEditors: wzc
 * @LastEditTime: 2021-10-25 19:11:02
 */

import Vue from 'vue'

export default new Vue()
